import React from 'react';
import styled from 'styled-components';
import { Form, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
// ローカルファイルインポート
import { Alert } from 'react-bootstrap';
import { nl2br } from 'helpers';
import { lang } from 'lang';

/**
 * バージョンフォームコンポーネント
 */
const VersionForm = (props) => {
  const { validate } = lang;
  const { isUpdate, register, values, onSubmit, formState, errors } = props;
  const validationMsg = {
    update_info: {
      required: validate.required,
      maxLength: validate.max_length.replace('%s', 2000),
    },
  };
  // エラーメッセージをレンダリングする
  const renderMessage = (key, type) => {
    const text = validationMsg[key][type];
    return (
      <Form.Group as={Col} md="12" className='form-group_alert'>
        {text && <Alert variant='warning' >{nl2br(text)}</Alert> }
      </Form.Group>
    );
  };
  return (
    <Form onSubmit={onSubmit}>
      <Form.Group as={Col} md="6">
        <Form.Label>File name</Form.Label>
        <Form.Control
          id='filename'
          type='text'
          defaultValue={isUpdate ? values.filename : ''}
          disabled={isUpdate}
        >
        </Form.Control>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Version{!isUpdate && <Span>(Mandatory)</Span>}</Form.Label>
        <Form.Control
          id='version'
          type='text'
          defaultValue={isUpdate ? values.version : ''}
          disabled={isUpdate}
        >
        </Form.Control>
      </Form.Group>
      <Form.Group as={Col} md="12">
        <Form.Label htmlFor='update-info'>
          Update information{!isUpdate && <Span>(Mandatory)</Span>}
        </Form.Label>
        <Form.Control as='textarea'
          id='update-info'
          name='update_info'
          defaultValue={isUpdate ? values.update_info : ''}
          maxLength={2000}
          className={errors.update_info ? 'input-warning' : ''}
          ref={
            register({ 
              required: true,
              maxLength: 2000,
            })
          }
          rows={10}
        />
      </Form.Group>
      {errors.update_info && renderMessage('update_info', errors.update_info.type)}
      <SubmitButton
        data-testid='submit-button'
        type='submit'
        disabled={formState.isSubmitting}
      >
        {isUpdate ? 'Update' : 'Add'}
      </SubmitButton> 
    </Form>
  );
};
VersionForm.propTypes = {
  isUpdate: PropTypes.bool,
  register: PropTypes.func,
  onSubmit: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  formState: PropTypes.object,
};
VersionForm.defaultProps = {
  isUpdate: false,
  values: {},
};
const SubmitButton = styled(Button)`
  margin-left: 5px;
  margin-bottom: 20px;
`;
const Span = styled.span`
  color: red;
  margin-left:10px;
`;
export default VersionForm;
